import { apiClientes } from "../../config/api";
import { AceiteAdesaoAeromedica } from "../../interfaces/entities/Aeromedica/AceiteAdesaoAeromedica";
import { TermoResponsabilidade } from "../../interfaces/entities/TermoResponsabilidade";
import { HttpResponse } from "../../interfaces/services/HttpResponse";
import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";

export const aceiteAdesaoAeromedica = async (): Promise<any | null> => {
    try {
        const response = await apiClientes.get('Beneficios/GetAceiteAdesaoAeromedica', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const termosAdesaoAeromedica = async (): Promise<any | null> => {
    try {
        const response = await apiClientes.get('Beneficios/GetTermoAeromedica', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getContratoAeromedica = async (): Promise<HttpResponse<TermoResponsabilidade> | null> => {
    try {
        const response = await apiClientes.get('Beneficios/GetContratoAeromedica', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const aceitarAdesaoAeromedica = async (aceiteAdesao: AceiteAdesaoAeromedica): Promise<HttpResponse<any> | null> => {
    try {
        const response = await apiClientes.post('Beneficios/AceitarAdesaoAeromedica', aceiteAdesao, {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` },
        });
        return response;
    } catch (error) {
        console.log({ error });
        throw error;
    }
}